import React from 'react';
import * as styled from '../styles/style';

class Notification extends React.Component {
  render() {
  	const { type, message } = this.props;
    const backgroundColor = type === 'success' ? 'gold' : 'tomato';
    const foregroundColor = type === 'success' ? 'black' : 'white';
    if (typeof message === 'undefined') {
      return null
    }
    else {
      return (
      	<styled.Notification type={backgroundColor} foregroundColor={foregroundColor} dangerouslySetInnerHTML={{__html: message}} />
    	);
    }
  }
}

export default Notification;